// src/app/core/init/permission.initializer.ts
import { EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { SecurityService } from '../services/security.service';
import { LocalStorageConstants } from '../../core/constants/local-storage';

export async function initializePermissions(envInjector: EnvironmentInjector): Promise<void> {
  return runInInjectionContext(envInjector, async () => {
    const securityService = inject(SecurityService);

    securityService.setUserAuthorities();
  });
}
